export const extractNodesFromViolations = (violations) => {
    const nodesCollection = [];
    violations.forEach(category => {
      category.nodes.forEach( node => nodesCollection.push({
        impact: category.impact,
        description: category.description,
        help: category.help,
        helpUrl: category.helpUrl,
        selector: node.target[0]
      }))
    });
    return nodesCollection;
  }